// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Search from "@hardwoods/XDL/Icons/Search";
import color from "@hardwoods/XDL/Utilities/color";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        padding: 15px 15px 20px;
        border-color: ${color("common.border")};
        border-style: solid;
        border-width: 0 1px;
    `,
};

searchWithinStyles.titleText = {
    variant: "h6",
    color: "text.main",
    size: 14,
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        margin-bottom: 10px;
    `,
};

searchWithinStyles.searchTextField = {
    iconProps: { src: Search },
    cssOverrides: {
        formField: css`
            width: 100%;
            ${getProp("theme.formField.defaultProps.cssOverrides.formField")}
        `,
    },
};
